import { FormPage } from 'components/formpage';
import styled from 'styled-components';

export const LLMForm = styled(FormPage)`
  display: flex;
  flex-direction: column;
  align-items: center;

  .back-button {
    align-self: start;
  }
`;
